import React, { createContext, useContext, useState } from "react";

const ThemeContext = createContext({ part2: false, setPart2: () => {} });

export function ThemeProvider({ children }) {
  const [part2, setPart2] = useState(false);
  return <ThemeContext.Provider value={{ part2, setPart2 }}>{children}</ThemeContext.Provider>;
}

export const useTheme = () => useContext(ThemeContext);
